function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import capitalize from "lodash/capitalize";
import React from "react";
import { getLoginDialogTitleAndDescription } from "~/components/acquisition-popup-container/display/helpers";
import { useSdkContext } from "~/components/contexts";
import { FollowButtonAction, isFollowType } from "~/components/follow-button/enums";
import { queryFromConfig } from "./actions";
import { StyledFollowButton, StyledRedirectButton } from "./styles";
export const useActionButtonRenderer = campaign => {
  var _campaign$theme;
  const {
    config,
    handleCheckIsFollowed,
    handleFollow,
    handleOpenLoginDialog,
    handleTrackGA,
    handleTrackGA4,
    user
  } = useSdkContext();
  const theme = (_campaign$theme = campaign.theme) !== null && _campaign$theme !== void 0 ? _campaign$theme : "follow";
  const ctaType = getCTAType(theme);
  const render = props => {
    var _campaign$content$pro, _campaign$content$ter, _campaign$content$red;
    const loginDialogDisplayCampaignName = campaign.name;
    const trackingCampaignName = campaign.campaign;
    switch (theme) {
      case "subscribe":
        const url = new URL(config.subscribe.host);
        url.searchParams.set("module", `semi-FPTO_${trackingCampaignName}`); // Cspell: disable-line
        url.searchParams.set("pgtype", "article");
        url.searchParams.set("promocode", (_campaign$content$pro = campaign.content.promoCode) !== null && _campaign$content$pro !== void 0 ? _campaign$content$pro : ""); // Cspell: disable-line
        url.searchParams.set("plan", (_campaign$content$ter = campaign.content.termCode) !== null && _campaign$content$ter !== void 0 ? _campaign$content$ter : "");
        return /*#__PURE__*/React.createElement(StyledRedirectButton, {
          url: url.toString(),
          onClick: () => {
            handleTrackGA({
              action: "Subscription Entry Point/Pop-up/Click",
              category: "Subscription Entry Point",
              label: trackingCampaignName
            });
            handleTrackGA4({
              action: "click",
              category: "promopopup",
              customized_parameters: {
                cta_type: ctaType,
                internal_campaign: trackingCampaignName,
                message: "Subscribe",
                step: "1"
              },
              subcategory: ""
            });
          }
        }, "Subscribe");
      case "link":
        return /*#__PURE__*/React.createElement(StyledRedirectButton, {
          url: (_campaign$content$red = campaign.content.redirectURL) !== null && _campaign$content$red !== void 0 ? _campaign$content$red : "",
          onClick: () => {
            var _campaign$content$red2, _campaign$content$red3;
            handleTrackGA({
              action: `Acquisition/${trackingCampaignName}/Link/Click`,
              category: "Acquisition",
              label: window.location.href
            });
            handleTrackGA4({
              action: "click",
              category: "promopopup",
              customized_parameters: {
                cta_type: ctaType,
                destination_url: (_campaign$content$red2 = campaign.content.redirectURL) !== null && _campaign$content$red2 !== void 0 ? _campaign$content$red2 : "",
                internal_campaign: trackingCampaignName,
                message: (_campaign$content$red3 = campaign.content.redirectTitle) !== null && _campaign$content$red3 !== void 0 ? _campaign$content$red3 : "",
                step: "1"
              },
              subcategory: ""
            });
          }
        }, campaign.content.redirectTitle);
      case "follow":
        if (!isFollowType(campaign.type)) return;
        const {
          name,
          tid,
          tids = [],
          type: followType
        } = campaign;
        const entityIds = tid ? [tid] : tids;
        const isFollowed = entityIds.every(entityId => handleCheckIsFollowed({
          entityId,
          followType
        }));
        return /*#__PURE__*/React.createElement(StyledFollowButton, _extends({}, props.followButtonProps, {
          disabled: isFollowed,
          isFollowing: isFollowed,
          onClick: action => {
            if (action === FollowButtonAction.Unfollow) return;
            handleTrackGA({
              action: `Acquisition/${trackingCampaignName}/Follow/Click`,
              category: "Acquisition",
              label: window.location.href
            });
            handleTrackGA4({
              action: "click",
              category: "follow",
              customized_parameters: {
                action_type: "follow",
                follow_type: "topic",
                internal_campaign: trackingCampaignName,
                topic_id: tid !== null && tid !== void 0 ? tid : tids.join(", "),
                trigger_point: "ppto"
              },
              subcategory: ""
            });
            handleTrackGA4({
              action: "click",
              category: "promopopup",
              customized_parameters: {
                cta_type: ctaType,
                internal_campaign: trackingCampaignName,
                message: "follow",
                step: "1"
              },
              subcategory: ""
            });
            if (!user) {
              const destination = new URL(window.location.href);
              destination.search = queryFromConfig({
                campaign: name
              });
              const {
                description,
                title
              } = getLoginDialogTitleAndDescription({
                campaignName: loginDialogDisplayCampaignName,
                type: followType
              });
              handleOpenLoginDialog({
                description,
                destination: destination.toString(),
                ga4CustomParameter: {
                  internal_campaign: trackingCampaignName,
                  trigger_point: "ppto"
                },
                title
              });
              return;
            }
            handleFollow({
              action,
              callback: () => {
                handleTrackGA({
                  action: `Acquisition/${trackingCampaignName}/Follow/${capitalize(followType)}`,
                  category: "Acquisition",
                  label: name
                });
                handleTrackGA4({
                  action: "sys",
                  category: "follow",
                  customized_parameters: {
                    action_type: "follow",
                    follow_type: "topic",
                    internal_campaign: trackingCampaignName,
                    topic_id: tid !== null && tid !== void 0 ? tid : tids.join(", "),
                    trigger_point: "ppto"
                  },
                  subcategory: "result"
                });
                if (props.handlePopupClose) props.handlePopupClose();
              },
              entityIds,
              followType
            });
          }
        }));
      default:
        return null;
    }
  };
  return {
    render
  };
};
export const getCTAType = theme => {
  switch (theme) {
    case "follow":
      return "follow";
    case "link":
      return "url_redirect";
    case "subscribe":
      return "subscribe";
    default:
      return "follow";
  }
};